var _rect, _rect2, _path, _path2, _path3, _rect3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCreateSessionIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 62,
    height: 62,
    rx: 31,
    fill: "#35A684",
    fillOpacity: 0.2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 22.5713,
    y: 31.1426,
    width: 18.8571,
    height: 11.1429,
    rx: 2,
    fill: "#35A684"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.8569 23.0006C26.8569 22.2905 27.4326 21.7148 28.1426 21.7148C28.8527 21.7148 29.4284 22.2905 29.4284 23.0006V24.7148C29.4284 25.4249 28.8527 26.0006 28.1426 26.0006C27.4326 26.0006 26.8569 25.4249 26.8569 24.7148V23.0006Z",
    fill: "#35A684"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5713 23.0006C34.5713 22.2905 35.1469 21.7148 35.857 21.7148C36.5671 21.7148 37.1427 22.2905 37.1427 23.0006V24.7148C37.1427 25.4249 36.5671 26.0006 35.857 26.0006C35.1469 26.0006 34.5713 25.4249 34.5713 24.7148V23.0006Z",
    fill: "#35A684"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.857 24.2871H31.1427V24.7157C31.1427 26.3725 29.7996 27.7157 28.1427 27.7157C26.4859 27.7157 25.1427 26.3725 25.1427 24.7157V24.2871H24.5713C23.4667 24.2871 22.5713 25.1825 22.5713 26.2871V27.43C22.5713 28.5345 23.4667 29.43 24.5713 29.43H39.4284C40.533 29.43 41.4284 28.5345 41.4284 27.43V26.2871C41.4284 25.1825 40.533 24.2871 39.4284 24.2871H38.857V24.7157C38.857 26.3725 37.5139 27.7157 35.857 27.7157C34.2001 27.7157 32.857 26.3725 32.857 24.7157V24.2871ZM34.5713 24.2871V24.7157C34.5713 25.4258 35.1469 26.0014 35.857 26.0014C36.5671 26.0014 37.1427 25.4258 37.1427 24.7157V24.2871H34.5713ZM26.857 24.7157V24.2871H29.4284V24.7157C29.4284 25.4258 28.8528 26.0014 28.1427 26.0014C27.4326 26.0014 26.857 25.4258 26.857 24.7157Z",
    fill: "#35A684"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 62,
    height: 62,
    rx: 31,
    stroke: "#35A684",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateSessionIcon);
export default __webpack_public_path__ + "static/media/create-session-icon.282278db.svg";
export { ForwardRef as ReactComponent };